import { useTranslate } from '@tolgee/react';
import { DetailCard } from '../DetailCard';
import { InfoBox } from './InfoBox';
import { useMemo } from 'react';
import { Divider } from 'antd';

interface ERPDetailProps {
  erpDetail: Conversation.Trade.ErpDetail;
}

export const ERPDetail = (props: ERPDetailProps) => {
  const { erpDetail } = props;
  const { t } = useTranslate();
  const {
    preWeight,
    realWeight,
    logisticsCompanyPriceWeight,
    processStatus,
    orderTags1,
    oaNoteContent,
  } = erpDetail;

  const options = useMemo(
    () => [
      {
        title: t('重量'),
        key: 'weight',
        value: (
          <>
            {preWeight ? (
              <span>
                {`预${preWeight}`}
                <Divider type="vertical" className="!border-l-content-200" />
              </span>
            ) : null}
            {realWeight ? (
              <span>
                {`称${realWeight}`}
                <Divider type="vertical" className="!border-l-content-200" />
              </span>
            ) : null}
            {logisticsCompanyPriceWeight ? (
              <span>
                {`计${logisticsCompanyPriceWeight}`}
                <Divider type="vertical" className="!border-l-content-200" />
              </span>
            ) : null}
          </>
        ),
      },
      {
        title: t('OA订单状态'),
        key: 'processStatus',
        value: processStatus,
      },
      {
        title: t('一级标签'),
        key: 'orderTags1',
        value: orderTags1,
      },
      {
        title: t('备注内容'),
        key: 'oaNoteContent',
        value: oaNoteContent,
      },
    ],
    [
      logisticsCompanyPriceWeight,
      oaNoteContent,
      orderTags1,
      preWeight,
      processStatus,
      realWeight,
      t,
    ],
  );

  return (
    <DetailCard title={t('ERP信息')}>
      <InfoBox list={options} />
    </DetailCard>
  );
};
